module.exports = __webpack_public_path__ + "img/ps-42.35a5327f.jpg";